import Box from '@component/Box';
import IconButton from '@component/buttons/IconButton';
import Card from '@component/Card';
import FlexBox from '@component/FlexBox';
import Grid from '@component/grid/Grid';
import Hidden from '@component/hidden/Hidden';
import Icon from '@component/icon/Icon';
import NavbarLayout from '@component/layout/NavbarLayout';
import ProductCard1List from '@component/products/ProductCard1List';
import ProductCard9List from '@component/products/ProductCard9List';
import ProductFilterCard from '@component/products/ProductFilterCard';
import Select from '@component/Select';
import Sidenav from '@component/sidenav/Sidenav';
import { H5, Paragraph } from '@component/Typography';
import React, { useCallback, useState, useEffect } from 'react';
import useWindowSize from '../../../hooks/useWindowSize';
import { useRouter } from 'next/router';
import ListingApi from 'pages/api/listing';
import { useSession } from 'next-auth/react';
import useDebounce from '@hook/useDebounce';

const ProductSearchResult = () => {
  const router = useRouter();

  const [view, setView] = useState('grid');
  const width = useWindowSize();
  const isTablet = width < 1025;
  const { data: session, status } = useSession();
 const loading = status === 'loading';;
  const [rating, setRating] = useState(null);
  const [minPrice, setMinPrice] = useState(null);
  const [maxPrice, setMaxPrice] = useState(null);
  const [searchItem, setSearchItem] = useState('');
  const [condition, setCondition] = useState(null);
  const [searchResult, setSearchResult] = useState([]);
  const [deliveryType, setDeliveryType] = useState(null);
  const [searchResultCount, setSearchResultCount] = useState(0);
  const [loggedInUserId, setLoggedInUserId] = useState(null);
  const maxVal = useDebounce<number>(maxPrice, 300);
  const minVal = useDebounce<number>(minPrice, 300);

  const onPriceChange = ({ min, max }) => {
    setMaxPrice(max);
    setMinPrice(min);
  };

  useEffect(() => {
    setSearchItem(`${router.query.keyword}`);
  }, [router]);

  useEffect(() => {
    if (searchItem === null) return;
    if (session) {
    }
    const fetchSearchResult = async () => {
      try {
        let keyword = searchItem;
        if (keyword === '' || keyword === null) {
          return;
        }
        if (session) {
          setLoggedInUserId(session.userId);
        }
        const { data, status } = await ListingApi.searchByParams(
          keyword,
          minVal,
          maxVal,
          condition,
          20,
          1,
          null,
          rating,
          deliveryType,
          loggedInUserId
        );
        if (status !== 200) {
          return;
        }
        setSearchResult(data.data);
        setSearchResultCount(data.total);
      } catch (err) {
        console.log('err-->', err);
      }
    };
    fetchSearchResult();
  }, [searchItem, condition, minVal, maxVal, deliveryType, rating, loggedInUserId]);

  const onMaxPriceChange = useCallback(
    (number) => {
      if (number === 0) {
        return setMaxPrice(null);
      }
      setMaxPrice(number);
    },
    [maxPrice]
  );

  const onConditionChange = useCallback((condition) => {
    if (condition === 'New') {
      setCondition(1);
    } else if (condition === 'Used') {
      setCondition(2);
    } else {
      setCondition(null);
    }
  }, []);

  const onDeliveryChange = useCallback((delivery) => {
    setDeliveryType(delivery);
  }, []);

  const onRatingChange = useCallback((rating) => {
    setRating(rating);
  }, []);

  const clearFilters = useCallback(() => {
    setCondition(null);
    setMaxPrice(null);
    setDeliveryType(null);
    setRating(null);
  }, []);

  const toggleView = useCallback(
    (v) => () => {
      setView(v);
    },
    []
  );

  return (
    <Box pt="20px">
      <FlexBox
        p="1.25rem"
        flexWrap="wrap"
        justifyContent="space-between"
        alignItems="center"
        mb="55px"
        elevation={5}
        as={Card}
      >
        <div>
          <H5>Searching for “{searchItem}”</H5>
          <Paragraph color="text.muted">{searchResultCount} results found</Paragraph>
        </div>
        <FlexBox alignItems="center" flexWrap="wrap">
          <Paragraph color="text.muted" mr="1rem">
            Short by:
          </Paragraph>
          <Box flex="1 1 0" mr="1.75rem" minWidth="150px">
            <Select placeholder="Short by" defaultValue={sortOptions[0]} options={sortOptions} />
          </Box>

          {/* <Paragraph color="text.muted" mr="0.5rem">
            View:
          </Paragraph>
          <IconButton size="small" onClick={toggleView('grid')}>
            <Icon
              variant="small"
              defaultcolor="auto"
              color={view === 'grid' ? 'primary' : 'inherit'}
            >
              grid
            </Icon>
          </IconButton>
          <IconButton size="small" onClick={toggleView('list')}>
            <Icon
              variant="small"
              defaultcolor="auto"
              color={view === 'list' ? 'primary' : 'inherit'}
            >
              menu
            </Icon>
          </IconButton> */}

          {isTablet && (
            <Sidenav
              position="left"
              scroll={true}
              handle={
                <IconButton size="small">
                  <Icon>options</Icon>
                </IconButton>
              }
            >
              <ProductFilterCard
                onConditionChange={onConditionChange}
                minPrice={minPrice}
                maxPrice={maxPrice}
                condition={condition}
                onDeliveryChange={onDeliveryChange}
                deliveryType={deliveryType}
                onRatingChange={onRatingChange}
                rating={rating}
                clearFilters={clearFilters}
                onChange={onPriceChange}
              />
            </Sidenav>
          )}
        </FlexBox>
      </FlexBox>

      <Grid container spacing={6}>
        <Hidden as={Grid} item lg={3} xs={12} down={1024}>
          <ProductFilterCard
            onConditionChange={onConditionChange}
            minPrice={minPrice}
            maxPrice={maxPrice}
            condition={condition}
            onDeliveryChange={onDeliveryChange}
            deliveryType={deliveryType}
            onRatingChange={onRatingChange}
            rating={rating}
            clearFilters={clearFilters}
            onChange={onPriceChange}
          />
        </Hidden>

        <Grid item lg={9} xs={12}>
          {view === 'grid' ? (
            <ProductCard1List
              productList={searchResult}
              keyword={searchItem}
              condition={condition}
              maxPrice={maxPrice}
              minPrice={minPrice}
            />
          ) : (
            <ProductCard9List />
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

const sortOptions = [
  { label: 'Relevance', value: 'Relevance' },
  { label: 'Date', value: 'Date' },
  { label: 'Price Low to High', value: 'Price Low to High' },
  { label: 'Price High to Low', value: 'Price High to Low' },
];

ProductSearchResult.layout = NavbarLayout;

export default ProductSearchResult;
